import axios from 'axios';
import csv from 'csvtojson';

export default class BDE {
  /**
   *
   * @param {Object} data
   * @param {Function} successCallback
   * @param {Function} failureCallback
   * This function reads csv file and uploads it
   */
  static uploadFile = (data, successCallback, failureCallback) => {
    let error = false;
    let message = '';
    Object.keys(data).map(key => {
      if (!data[key]) {
        message += `${key} is missing`;
        error = true;
      }
    });
    if (error) {
      failureCallback(message);
    }

    const reader = new FileReader();
    reader.readAsText(data.file);
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = async () => {
      data['data'] = reader.result;
      let result = await this.upload(data);
      if (result == 'error') {
        failureCallback('Error uploading a file.');
      }

      successCallback(result);
    };
  };

  static upload = async data => {
    let arr = [];
    let flag = false;
    let statusCode = 200;
    await csv()
      .fromString(data.data)
      .then(csvRow => {
        csvRow.forEach(row => {
          if (data.event_id) {
            let keys = Object.keys(row);
            if(keys.includes('guest_of_honor') && row.guest_of_honor){
              row['guest_of_honor'] = JSON.parse(row['guest_of_honor'].toLowerCase());
            } else {
              row['guest_of_honor'] = false;
            }
            row['event_id'] = parseInt(data.event_id);
            arr.push(row);
          } else if (data.sport_id) {
            row['sport_id'] = parseInt(data.sport_id);

            if (data.option_type_id) {
              row['option_type_id'] = parseInt(data.option_type_id);
            }

            arr.push(row);
          } else if (data.game_type_id == 3) {
            if (data.edit === 'true' && data.quarter_id > 1) {
              if (!row['event_id']) {
                statusCode = 404;
                flag = true;
              }
            }
            if (flag) {
              arr = [];
            } else {
              arr.push(row);
            }
          } else {
            arr.push(row);
          }
        });
      });
    if (statusCode == 404) {
      return 'error';
    } else {
      return arr;
    }
  };
}
